import { useSyncExternalStore } from 'react';

// Whether the phone's full-screen call screen (PhoneCallScreen, expanded) is
// on screen, for UI outside the voice tree that has to keep clear of its
// controls, like the toasts in Notifications. Its geometry is published
// separately as CSS variables on <html> (`--call-screen-minimize-width`,
// `--call-screen-caller-width`).
let shown = false;
const listeners = new Set<() => void>();

export function setFullScreenCallShown(value: boolean) {
	if (shown === value) return;
	shown = value;
	listeners.forEach((listener) => listener());
}

const subscribe = (onChange: () => void) => {
	listeners.add(onChange);
	return () => {
		listeners.delete(onChange);
	};
};

/** True while the full-screen call screen shows; false when minimised to the bar or with no call. */
export function useFullScreenCallShown() {
	return useSyncExternalStore(subscribe, () => shown, () => false);
}
